// extracted by mini-css-extract-plugin
export default {"root":"refreshStatus_root__uCWpu","dot":"refreshStatus_dot__fwZV9","text":"refreshStatus_text__mrg5H","num":"refreshStatus_num__RWW4M","btn":"refreshStatus_btn__jkmKS"};